import PropTypes from "prop-types";

import SvgPlanetMurcury from "../../components/svg/PlanetMurcury";
import SvgPlanetVenus from "../../components/svg/PlanetVenus";
import SvgPlanetEarth from "../../components/svg/PlanetEarth";
import SvgPlanetMars from "../../components/svg/PlanetMars";
import SvgPlanetSaturn from "../../components/svg/PlanetSaturn";
import SvgPlanetJupiter from "../../components/svg/PlanetJupiter";
import SvgPlanetUranus from "../../components/svg/PlanetUranus";
import SvgPlanetNeptune from "../../components/svg/PlanetNeptune";
import SvgPlanetPluto from "../../components/svg/PlanetPluto";

export const UPDATE_COLLECTIONS = 'UPDATE_COLLECTIONS';
export const UPDATE_CARDS = 'UPDATE_CARDS';
export const UPDATE_CURRENT = 'UPDATE_CURRENT';
export const UPDATE_SELECTED = 'UPDATE_SELECTED';
export const UPDATE_FLIPPED = 'UPDATE_FLIPPED';
export const UPDATE_SCORE = 'UPDATE_SCORE';
export const UPDATE_COMPLETE = 'UPDATE_COMPLETE';
export const UPDATE_PROCESSING = 'UPDATE_PROCESSING';
export const RESTORE_FLIP_STATE = 'RESTORE_FLIP_STATE';

export const FLIP_MATCH_STATE_TYPE = PropTypes.shape({
    complete: PropTypes.bool,
    collection: PropTypes.object,
    collections: PropTypes.object,
    dealTrigger: PropTypes.number,
    flipped: PropTypes.array,
    selected: PropTypes.array,
    current: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.bool
    ]),
    score: PropTypes.number,
}).isRequired;

export const FLIP_ICON_TYPE = PropTypes.oneOfType([
    PropTypes.shape({
        tag: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.bool
        ]),
        props: PropTypes.object
    }),
    PropTypes.bool
]);

export const CARDS = {
    practice: {
        name: "practice",
        title: "Practice",
        description: "Match the cards and plot your PRACTICE course across the solar system!",
        theme: "space",
        cards: [
            {
                name: "mercury1",
                group: "mercury",
                frontIcon: {
                    tag: SvgPlanetMurcury,
                    props: {
                        width: 26,
                        height: 26
                    }
                },
                frontText: "Mercury",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "mercury2",
                group: "mercury",
                frontIcon: {
                    tag: SvgPlanetMurcury,
                    props: {
                        width: 26,
                        height: 26
                    }
                },
                frontText: "Mercury",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "venus1",
                group: "venus",
                frontIcon: {
                    tag: SvgPlanetVenus,
                    props: {
                        width: 40,
                        height: 40
                    }
                },
                frontText: "Venus",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "venus2",
                group: "venus",
                frontIcon: {
                    tag: SvgPlanetVenus,
                    props: {
                        width: 40,
                        height: 40
                    }
                },
                frontText: "Venus",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "earth1",
                group: "earth",
                frontIcon: {
                    tag: SvgPlanetEarth,
                    props: {
                        width: 45,
                        height: 45
                    }
                },
                frontText: "Earth",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "earth2",
                group: "earth",
                frontIcon: {
                    tag: SvgPlanetEarth,
                    props: {
                        width: 45,
                        height: 45
                    }
                },
                frontText: "Earth",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "mars2",
                group: "mars",
                frontIcon: {
                    tag: SvgPlanetMars,
                    props: {
                        width: 30,
                        height: 30
                    }
                },
                frontText: "Mars",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "mars1",
                group: "mars",
                frontIcon: {
                    tag: SvgPlanetMars,
                    props: {
                        width: 30,
                        height: 30
                    }
                },
                frontText: "Mars",
                backIcon: false,
                backText: "",
                theme: "space"
            }
        ]
    },
    planets: {
        name: "planets",
        title: "Planets",
        description: "Match the cards and plot your course across the solar system!",
        theme: "space",
        cards: [
            {
                name: "mercury1",
                group: "mercury",
                frontIcon: {
                    tag: SvgPlanetMurcury,
                    props: {
                        width: 26,
                        height: 26
                    }
                },
                frontText: "Mercury",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "mercury2",
                group: "mercury",
                frontIcon: {
                    tag: SvgPlanetMurcury,
                    props: {
                        width: 26,
                        height: 26
                    }
                },
                frontText: "Mercury",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "venus1",
                group: "venus",
                frontIcon: {
                    tag: SvgPlanetVenus,
                    props: {
                        width: 40,
                        height: 40
                    }
                },
                frontText: "Venus",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "venus2",
                group: "venus",
                frontIcon: {
                    tag: SvgPlanetVenus,
                    props: {
                        width: 40,
                        height: 40
                    }
                },
                frontText: "Venus",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "earth1",
                group: "earth",
                frontIcon: {
                    tag: SvgPlanetEarth,
                    props: {
                        width: 45,
                        height: 45
                    }
                },
                frontText: "Earth",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "earth2",
                group: "earth",
                frontIcon: {
                    tag: SvgPlanetEarth,
                    props: {
                        width: 45,
                        height: 45
                    }
                },
                frontText: "Earth",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "mars2",
                group: "mars",
                frontIcon: {
                    tag: SvgPlanetMars,
                    props: {
                        width: 30,
                        height: 30
                    }
                },
                frontText: "Mars",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "mars1",
                group: "mars",
                frontIcon: {
                    tag: SvgPlanetMars,
                    props: {
                        width: 30,
                        height: 30
                    }
                },
                frontText: "Mars",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "jupiter2",
                group: "jupiter",
                frontIcon: {
                    tag: SvgPlanetJupiter,
                    props: {
                        width: 85,
                        height: 85
                    }
                },
                frontText: "Jupiter",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "jupiter1",
                group: "jupiter",
                frontIcon: {
                    tag: SvgPlanetJupiter,
                    props: {
                        width: 85,
                        height: 85
                    }
                },
                frontText: "Jupiter",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "saturn1",
                group: "saturn",
                frontIcon: {
                    tag: SvgPlanetSaturn,
                    props: {
                        width: 90,
                        height: 84
                    }
                },
                frontText: "Saturn",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "saturn2",
                group: "saturn",
                frontIcon: {
                    tag: SvgPlanetSaturn,
                    props: {
                        width: 90,
                        height: 84
                    }
                },
                frontText: "Saturn",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "uranus1",
                group: "uranus",
                frontIcon: {
                    tag: SvgPlanetUranus,
                    props: {
                        width: 60,
                        height: 60
                    }
                },
                frontText: "Uranus",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "uranus2",
                group: "uranus",
                frontIcon: {
                    tag: SvgPlanetUranus,
                    props: {
                        width: 60,
                        height: 60
                    }
                },
                frontText: "Uranus",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "neptune1",
                group: "neptune",
                frontIcon: {
                    tag: SvgPlanetNeptune,
                    props: {
                        width: 60,
                        height: 60
                    }
                },
                frontText: "Neptune",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "neptune2",
                group: "neptune",
                frontIcon: {
                    tag: SvgPlanetNeptune,
                    props: {
                        width: 60,
                        height: 60
                    }
                },
                frontText: "Neptune",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "pluto1",
                group: "pluto",
                frontIcon: {
                    tag: SvgPlanetPluto,
                    props: {
                        width: 22,
                        height: 22
                    }
                },
                frontText: "Pluto",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "pluto2",
                group: "pluto",
                frontIcon: {
                    tag: SvgPlanetPluto,
                    props: {
                        width: 22,
                        height: 22
                    }
                },
                frontText: "Pluto",
                backIcon: false,
                backText: "",
                theme: "space"
            }
        ]
    },
    planetsHard: {
        name: "planetsHard",
        title: "Planets (Hard)",
        description: "Match the pics to the text and plot your course across the solar system!",
        theme: "space",
        cards: [
            {
                name: "mercury1",
                group: "mercury",
                frontIcon: {
                    tag: SvgPlanetMurcury,
                    props: {
                        width: 26,
                        height: 26
                    }
                },
                frontText: "",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "mercury2",
                group: "mercury",
                frontIcon: false,
                frontText: "Mercury",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "venus1",
                group: "venus",
                frontIcon: {
                    tag: SvgPlanetVenus,
                    props: {
                        width: 40,
                        height: 40
                    }
                },
                frontText: "",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "venus2",
                group: "venus",
                frontIcon: false,
                frontText: "Venus",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "earth1",
                group: "earth",
                frontIcon: {
                    tag: SvgPlanetEarth,
                    props: {
                        width: 45,
                        height: 45
                    }
                },
                frontText: "",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "earth2",
                group: "earth",
                frontIcon: false,
                frontText: "Earth",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "mars2",
                group: "mars",
                frontIcon: {
                    tag: SvgPlanetMars,
                    props: {
                        width: 30,
                        height: 30
                    }
                },
                frontText: "",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "mars1",
                group: "mars",
                frontIcon: false,
                frontText: "Mars",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "jupiter2",
                group: "jupiter",
                frontIcon: {
                    tag: SvgPlanetJupiter,
                    props: {
                        width: 85,
                        height: 85
                    }
                },
                frontText: "",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "jupiter1",
                group: "jupiter",
                frontIcon: false,
                frontText: "Jupiter",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "saturn1",
                group: "saturn",
                frontIcon: {
                    tag: SvgPlanetSaturn,
                    props: {
                        width: 90,
                        height: 84
                    }
                },
                frontText: "",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "saturn2",
                group: "saturn",
                frontIcon: false,
                frontText: "Saturn",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "uranus1",
                group: "uranus",
                frontIcon: {
                    tag: SvgPlanetUranus,
                    props: {
                        width: 60,
                        height: 60
                    }
                },
                frontText: "",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "uranus2",
                group: "uranus",
                frontIcon: false,
                frontText: "Uranus",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "neptune1",
                group: "neptune",
                frontIcon: {
                    tag: SvgPlanetNeptune,
                    props: {
                        width: 60,
                        height: 60
                    }
                },
                frontText: "",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "neptune2",
                group: "neptune",
                frontIcon: false,
                frontText: "Neptune",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "pluto1",
                group: "pluto",
                frontIcon: {
                    tag: SvgPlanetPluto,
                    props: {
                        width: 22,
                        height: 22
                    }
                },
                frontText: "",
                backIcon: false,
                backText: "",
                theme: "space"
            }, {
                name: "pluto2",
                group: "pluto",
                frontIcon: false,
                frontText: "Pluto",
                backIcon: false,
                backText: "",
                theme: "space"
            }
        ]
    },
    /* alphabet: {
        title: "Alphabet",
        description: "",
        theme: "alphabet",
        cards: [
            {
                name: "a",
                group: "a",
                front: "a",
                back: "a",
            }, {
                name: "b",
                group: "b",
                front: "b",
                back: "b",
            },
            {
                name: "c",
                group: "c",
                front: "c",
                back: "c",
            },
            {
                name: "d",
                group: "d",
                front: "d",
                back: "d",
            },
            {
                name: "e",
                group: "e",
                front: "e",
                back: "e",
            },
            {
                name: "f",
                group: "f",
                front: "f",
                back: "f",
            },
            {
                name: "g",
                group: "g",
                front: "g",
                back: "g",
            },
            {
                name: "h",
                group: "h",
                front: "h",
                back: "h",
            },
            {
                name: "i",
                group: "i",
                front: "i",
                back: "i",
            },
            {
                name: "j",
                group: "j",
                front: "j",
                back: "j",
            },
            {
                name: "k",
                group: "k",
                front: "k",
                back: "k",
            },
            {
                name: "l",
                group: "l",
                front: "l",
                back: "l",
            },
            {
                name: "m",
                group: "m",
                front: "m",
                back: "m",
            },
            {
                name: "n",
                group: "n",
                front: "n",
                back: "n",
            },
            {
                name: "o",
                group: "o",
                front: "o",
                back: "o",
            },
            {
                name: "p",
                group: "p",
                front: "p",
                back: "p",
            },
            {
                name: "q",
                group: "q",
                front: "q",
                back: "q",
            },
            {
                name: "r",
                group: "r",
                front: "r",
                back: "r",
            },
            {
                name: "s",
                group: "s",
                front: "s",
                back: "s",
            },
            {
                name: "t",
                group: "t",
                front: "t",
                back: "t",
            },
            {
                name: "u",
                group: "u",
                front: "u",
                back: "u",
            },
            {
                name: "v",
                group: "v",
                front: "v",
                back: "v",
            },
            {
                name: "w",
                group: "w",
                front: "w",
                back: "w",
            },
            {
                name: "x",
                group: "x",
                front: "x",
                back: "x",
            },
            {
                name: "y",
                group: "y",
                front: "y",
                back: "y",
            },
            {
                name: "z",
                group: "z",
                front: "z",
                back: "z",
            },
            {
                name: "aa",
                group: "a",
                front: "a",
                back: "a",
            },
            {
                name: "bb",
                group: "b",
                front: "b",
                back: "b",
            },
            {
                name: "cc",
                group: "c",
                front: "c",
                back: "c",
            },
            {
                name: "dd",
                group: "d",
                front: "d",
                back: "d",
            },
            {
                name: "ee",
                group: "e",
                front: "e",
                back: "e",
            },
            {
                name: "ff",
                group: "f",
                front: "f",
                back: "f",
            },
            {
                name: "gg",
                group: "g",
                front: "g",
                back: "g",
            },
            {
                name: "hh",
                group: "h",
                front: "h",
                back: "h",
            },
            {
                name: "ii",
                group: "i",
                front: "i",
                back: "i",
            },
            {
                name: "jj",
                group: "j",
                front: "j",
                back: "j",
            },
            {
                name: "kk",
                group: "k",
                front: "k",
                back: "k",
            },
            {
                name: "ll",
                group: "l",
                front: "l",
                back: "l",
            },
            {
                name: "mm",
                group: "m",
                front: "m",
                back: "m",
            },
            {
                name: "nn",
                group: "n",
                front: "n",
                back: "n",
            },
            {
                name: "oo",
                group: "o",
                front: "o",
                back: "o",
            },
            {
                name: "pp",
                group: "p",
                front: "p",
                back: "p",
            },
            {
                name: "qq",
                group: "q",
                front: "q",
                back: "q",
            },
            {
                name: "rr",
                group: "r",
                front: "r",
                back: "r",
            },
            {
                name: "ss",
                group: "s",
                front: "s",
                back: "s",
            },
            {
                name: "tt",
                group: "t",
                front: "t",
                back: "t",
            },
            {
                name: "uu",
                group: "u",
                front: "u",
                back: "u",
            },
            {
                name: "vv",
                group: "v",
                front: "v",
                back: "v",
            },
            {
                name: "ww",
                group: "w",
                front: "w",
                back: "w",
            },
            {
                name: "xx",
                group: "x",
                front: "x",
                back: "x",
            },
            {
                name: "yy",
                group: "y",
                front: "y",
                back: "y",
            },
            {
                name: "zz",
                group: "z",
                front: "z",
                back: "z",
            }
        ]
    }
    */
};